<template>
	<section class="tier-table" :style="tableVars">
		<div class="container">
			<div class="tier-table__scroll">
				<table class="tier-table__table">
					<thead>
						<tr>
							<th
								v-for="(header, i) in headers"
								:key="i"
								:style="columnWidths[i] ? { width: columnWidths[i] } : null"
							>
								{{ header }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, r) in rows" :key="r">
							<!-- v-html: the Legend row picks part of its benefits out in
									 the accent colour with a <span class="accent"> -->
							<td
								v-for="(cell, c) in row"
								:key="c"
								:class="{ 'is-first': c === 0 }"
								v-html="cell"
							></td>
						</tr>
					</tbody>
				</table>
			</div>

			<p v-if="note" class="tier-table__note">{{ note }}</p>
		</div>
	</section>
</template>

<script>
export default {
	name: 'TierTable',
	props: {
		headers: { type: Array, default: () => [] },
		// array of rows, each row an array of cells matching `headers` in length
		rows: { type: Array, default: () => [] },
		note: { type: String, default: '' },
		// Optional per-column widths. Left to auto layout the benefits column
		// takes more than half the table, because the Legend row's copy is by far
		// the longest cell; fixing the widths lets it wrap instead.
		columnWidths: { type: Array, default: () => [] },
		backgroundColor: { type: String, default: '#040428' },
		borderColor: { type: String, default: '#4656FF' },
		headerTextColor: { type: String, default: '#01DBA8' },
		// the leading column (tier label) is picked out in the accent colour too
		firstColumnColor: { type: String, default: '#01DBA8' },
		textColor: { type: String, default: '#FFFFFF' },
	},
	components: {},
	data: () => ({}),
	created() {},
	computed: {
		tableVars() {
			return {
				'--bg': this.backgroundColor,
				'--border': this.borderColor,
				'--header-text': this.headerTextColor,
				'--first-col': this.firstColumnColor,
				'--text': this.textColor,
			};
		},
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
.tier-table {
	background: var(--bg);
	padding: 0 0 60px;

	@media (max-width: $breakpoint-sm) {
		padding-bottom: 40px;
	}
}

// between the phone and the desktop layout the table is too wide to fit but
// still too big to shrink readably, so it scrolls inside itself
.tier-table__scroll {
	width: 100%;
	overflow-x: auto;
}

.tier-table__table {
	width: 100%;
	min-width: 720px;
	border-collapse: collapse;
	table-layout: fixed;
	text-align: center;

	// the mockup fits the whole table on the phone rather than scrolling it
	@media (max-width: $breakpoint-sm) {
		min-width: 0;
	}
}

.tier-table__table th,
.tier-table__table td {
	border: 1px solid var(--border);
	padding: 14px 12px;
	font-size: $text-m;
	line-height: 20px;

	@media (max-width: $breakpoint-sm) {
		padding: 8px 4px;
		font-size: 10px;
		line-height: 14px;
	}
}

.tier-table__table th {
	color: var(--header-text);
	font-family: 'HKNova-Bold', sans-serif;
	text-transform: uppercase;
}

.tier-table__table td {
	color: var(--text);
	font-family: 'HKNova-Bold', sans-serif;

	&.is-first {
		color: var(--first-col);
	}

	&::v-deep .accent {
		color: var(--first-col);
	}
}

.tier-table__note {
	color: var(--text);
	font-size: $text-s;
	line-height: 20px;
	margin-top: 24px;
	opacity: 0.8;

	@media (max-width: $breakpoint-sm) {
		text-align: center;
	}
}
</style>
